var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGettingStartedProjectsBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1471 69.8528 0 45 0C20.1471 0 0 20.1471 0 45C0 69.8528 20.1471 90 45 90Z",
    fill: "#DEF6FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 40C49.1421 40 52.5 36.6421 52.5 32.5C52.5 28.3579 49.1421 25 45 25C40.8579 25 37.5 28.3579 37.5 32.5C37.5 36.6421 40.8579 40 45 40Z",
    fill: "#0C6CDE",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 62.5C61.6421 62.5 65 59.1421 65 55C65 50.8579 61.6421 47.5 57.5 47.5C53.3579 47.5 50 50.8579 50 55C50 59.1421 53.3579 62.5 57.5 62.5Z",
    fill: "#0C6CDE",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 62.5C36.6421 62.5 40 59.1421 40 55C40 50.8579 36.6421 47.5 32.5 47.5C28.3579 47.5 25 50.8579 25 55C25 59.1421 28.3579 62.5 32.5 62.5Z",
    fill: "#0C6CDE",
    stroke: "#0C6CDE",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGettingStartedProjectsBlue);
export default __webpack_public_path__ + "static/media/Icon_GettingStarted_Projects_Blue.3c2742c293a9b31607c1c3f320ce3a2c.svg";
export { ForwardRef as ReactComponent };